import SettingsTabBase from "./SettingsTabBase.jsx";
import { SETTING_TAB_WIDGET_KEYS } from "../../../other/constants/OtherKeys.jsx";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";
import { getDivider } from "../../../other/utils/utils.jsx";
import { userPreferences } from "../../../react/context/bryntumContext.jsx";
import { StringHelper } from "@bryntum/schedulerpro";

export default class SettingsPersonalScheduleTab extends SettingsTabBase {
  static get $name() {
    return "SettingsPersonalScheduleTab";
  }

  static get type() {
    return "Settingspersonalscheduletab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.personalSchedularTab;
  }

  /**
   * Creates a checkbox configuration to avoid repetition.
   */
  static createCheckbox(text, name) {
    return {
      type: "checkbox",
      text,
      name,
      onPaint: "up.onLoadAppearanceSetting",
      onChange: "up.onUpdateAppearanceSetting",
    };
  }

  static createRadioGroup() {
    return ["Center justify the current-time line to focus on today", "Left justify the current-time line to focus on tomorrow"]
      .reduce((acc, text, index) => {
        const ref = index === 0 ? "centerJustifyRedLineToday" : "leftJustifyRedLineTomorrow";
        acc[ref] = {
          type: "radio",
          name: PERSISTENCE_STATE_KEYS.centerSchedulerLineOnToday,
          ref,
          color: 'b-blue',
          text,
          cls: "swivu-timeScale-radio !mx-[auto] my-[0.3em]",
          onChange: "up.onRadioChange",
        };
        return acc;
      }, {});
  }

  static get configurable() {
    return {
      title: "Personal Schedule Settings",
      cls: "p-[1em]",
      defaults: {
        cls: "flex-[1_0_100%] @md:flex-[1_0_50%]",
        labelWidth: "11em",
      },
      items: {
        timelineMouseZooming: this.createCheckbox("Disable Mouse Wheel & Trackpad Timeline Zooming", PERSISTENCE_STATE_KEYS.disableTimelineZoomOnMouse),
        enableRedundantTaskEvents: this.createCheckbox("Enable redundant task events within time ranges", PERSISTENCE_STATE_KEYS.enableRedundantTaskEvents),
        divider: getDivider({ text: "Schedule Highlighting", cls: 'my-[1.5em]' }),
        selectedRowHighlight: this.createCheckbox("Enable highlighting of the recently selected row in the schedule", PERSISTENCE_STATE_KEYS.selectedRowHighlight),
        hoverGridCellHighlight: this.createCheckbox("Enable hover highlighting of grid cells in the schedule", PERSISTENCE_STATE_KEYS.hoverGridCellHighlight),
        hoverTaskEventHighlight: this.createCheckbox("Enable hover highlighting of task events in the schedule", PERSISTENCE_STATE_KEYS.hoverTaskEventHighlight),
        dividerRefocusContainer: getDivider({ text: "Schedule Timeline Focusing", cls: 'my-[1.5em]' }),
        ...this.createRadioGroup(),
        redistributeSubGridPanels: this.createCheckbox("When centering or left justifying the timeline, always tidy up the columns", PERSISTENCE_STATE_KEYS.redistributeSubGridPanels),
      }
    };
  }

  loadRecord(record, context) {
    super.loadRecord(record, context);

    const isCentered = JSON.parse(userPreferences.getSetting(PERSISTENCE_STATE_KEYS.centerSchedulerLineOnToday, true));
    this.widgetMap.centerJustifyRedLineToday.value = isCentered;
    this.widgetMap.leftJustifyRedLineTomorrow.value = !isCentered;
  }

  onLoadAppearanceSetting({ source }) {
    this.suspendEvents();
    const DEFAULT_SETTINGS_VALUE = [PERSISTENCE_STATE_KEYS.disableTimelineZoomOnMouse, PERSISTENCE_STATE_KEYS.hoverGridCellHighlight, PERSISTENCE_STATE_KEYS.redistributeSubGridPanels].includes(source.name);
    source.value = StringHelper.safeJsonParse(userPreferences.getSetting(source.name, DEFAULT_SETTINGS_VALUE));
    this.resumeEvents();
  }

  onUpdateAppearanceSetting({ source, userAction }) {
    if (userAction) {
      userPreferences.updateSetting(source.name, String(source.value));
    }
  }

  onRadioChange({ source, userAction }) {
    if (userAction) {
      userPreferences.updateSetting(PERSISTENCE_STATE_KEYS.centerSchedulerLineOnToday, String(source.ref.includes("centerJustifyRedLineToday")));
    }
  }
}

SettingsPersonalScheduleTab.initClass();
